const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the template parser component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('templateParser', ['Application', function (Application) {
  return {
    restrict: 'E',
    scope: {
      message: '='
    },
    template: require('../../templates/directives/continu-template-parser.html'),
    controller: ['$scope', '$sce', function ($scope, $sce) {
      var self = this;
      var domain = Application.navigation.getHost();
      self.parsedMessage = '';
      self.replaceLinks = function(text) {
        var updated = text;
        var makeLink = function(item) {
          if (item[0] !== '<' || item[item.length - 1] !== '>') {
            return null;
          }

          item = item.substring(1, item.length - 1);
          item = item.split('|');

          if (!item.length || item.length !== 2) {
            return null;
          }

          var testInternal = item[0].split(domain + '/#/');
          if (testInternal.length && testInternal.length === 2) {
            item[0] = '/#/' + testInternal[1];
          }

          return '<a href="' + item[0] + '">' + item[1] + '</a>';
        };

        var open = [];
        var close = [];
        for (var i = 0; i < text.length; i++) {
          if (text[i] === '<') {
            open.push(i);
            if (open.length <= close.length) {
              return 'This message can not be displayed';
            }
          }
          if (text[i] === '>') {
            close.push(i);
            if (close.length > open.length) {
              return 'This message can not be displayed';
            }
          }
        }

        if (open.length !== close.length) {
          return 'This message can not be displayed';
        }

        for (var i = 0; i < open.length; i++) {
          var original = text.substring(open[i], close[i] + 1);
          var link  = makeLink(original);
          if (!link) {
            return 'This message can not be displayed';
          }
          updated = updated.replace(original, link);
        }

        return updated;
      };

      self.parsedMessage = '<div>' + self.replaceLinks($scope.message) + '</div>';
      $sce.trustAsHtml(self.parsedMessage);

    }],
    controllerAs: 'parser'
  };
}]);
